module.exports = __webpack_public_path__ + "images/users/kaitori_focused_items/trading_cards/5_03868898f7bc6ff18ee2b29801238d4b.jpg";